module.exports = __webpack_public_path__ + "static/media/guillaume-de-germain-fgmLRBlUIpc_small.0c80fe25.jpg";